import api from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'
import { FamilyContact, ModifiedAddress } from 'models/Auth'

export interface UpdateUserDataProps {
  address?: ModifiedAddress
  familyContact?: FamilyContact
}

export const updateUserData = async ({
  address,
  familyContact
}: UpdateUserDataProps): Promise<string> => {
  const payload = {
    ...(address && {
      address_data: {
        cep: address.cep,
        address: address.address,
        address_number: address.number,
        complement: address.complement || 'N/A',
        neighborhood: address.neighborhood,
        city: address.city,
        state: address.state
      }
    }),
    ...(familyContact && {
      relative_data: {
        relative_full_name: familyContact.fullName,
        relative_phone_number: familyContact.phone,
        relationship_degree: familyContact.relationship
      }
    })
  }

  const response = await api.patch(apiEndpoints.ME, payload)
  return String(response?.status)
}